import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { DefaultTheme, media } from "@styles";

export const AddToCartSelection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
`;

export const DesignerHeader = styled.a`
  ${({ theme }) => {
    const { typography, space } = theme as DefaultTheme;

    return css`
      font-size: 16px;
      color: #71797e;
      font-weight: ${typography.extraBoldFontWeight};
      padding-top: ${space[3]};
      text-align: left;

      &:hover {
        color: ${theme.colors.tertiaryLight};
      }

      svg {
        color: ${theme.colors.tertiaryLight};
        font-size: 28px;
        margin-top: -3px;
        font-weight: 100;
      }

      ${media.mediumScreen`
        padding-top: 0;
        padding-bottom: 0.5rem;
        font-size: 16px;
      `};
    `;
  }}
`;

export const ProductNameHeader = styled.h1`
  ${({ theme }) => {
    const { typography, space } = theme as DefaultTheme;

    return css`
      text-transform: uppercase;
      font-size: ${typography.h4FontSize};
      font-weight: ${typography.extraBoldFontWeight};
      padding-top: ${space[3]};
      text-align: left;

      ${media.mediumScreen`
        padding-top: 0;
        font-size: ${typography.baseFontSize};
      `};
    `;
  }}
`;

export const ProductSizeHeader = styled.h3`
  ${({ theme }) => {
    const { typography } = theme as DefaultTheme;

    return css`
      font-size: ${typography.h4FontSize};
      margin-top: 5px;
      margin-bottom: 27px;
      text-align: left;
    `;
  }}
`;

export const ProductPricing = styled.h4`
  ${({ theme }) => {
    const { typography } = theme as DefaultTheme;

    return css`
      font-weight: ${typography.boldFontWeight};
      margin-bottom: 5px;
    `;
  }}
`;

export const DeliveryDate = styled.h4`
  ${({ theme }) => {
    const { typography, colors } = theme as DefaultTheme;

    return css`
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 5px;
      font-size: ${typography.smallFontSize};
      margin-bottom: 16px;
      padding: 12px;
      background-color: ${colors.successGreen};
    `;
  }}
`;

export const AfterPay = styled.p`
  ${({ theme }) => {
    const { typography, spacing } = theme as DefaultTheme;

    return css`
      font-size: ${typography.smallFontSize};
      margin-bottom: ${spacing.spacer};
      color: #a1a1a1;
      display: flex;
      align-items: center;
      gap: 5px;
    `;
  }}
`;

export const ProductDescription = styled.p`
  ${({ theme }) => {
    const { typography, spacing } = theme as DefaultTheme;

    return css`
      font-size: ${typography.smallFontSize};
      margin-bottom: ${spacing.spacer};
      display: none;

      ${media.mediumScreen`
        display: block;
    `};
    `;
  }}
`;

export const UndiscountedPrice = styled.span`
  ${({ theme }) => {
    const { typography, colors } = theme as DefaultTheme;

    return css`
      text-decoration: line-through;
      color: ${colors.baseFontColorSemiTransparent};
      font-size: ${typography.smallFontSize};
    `;
  }}
`;

export const VariantPicker = styled.div`
  ${({ theme }) => {
    const { typography, spacing } = theme as DefaultTheme;

    return css`
      display: grid;
      margin-top: 20px;
      width: 280px;
      justify-items: start;

      .react-select-wrapper,
      .input {
        width: 75%;
        margin-bottom: ${spacing.spacer};
      }

      .chakra-button {
        height: 45px;
        font-size: ${theme.typography.baseFontSize};
        font-weight: ${typography.extraBoldFontWeight};
        width: 100%;
      }
    `;
  }}
`;

export const ChangeDatePicker = styled.div`
  ${({ theme }) => {
    const { spacing, typography } = theme as DefaultTheme;

    return css`
      display: grid;
      margin-top: 20px;
      width: 280px;
      justify-items: start;

      .react-select-wrapper,
      .input {
        width: 75%;
        margin-bottom: ${spacing.spacer};
      }

      .chakra-button {
        height: auto;
        font-size: ${theme.typography.baseFontSize};
        font-weight: ${typography.extraBoldFontWeight};
        width: 100%;
        border: none;
        justify-items: start;
        padding: 0;
        text-decoration: underline;
      }

      .chakra-button:hover {
        background-color: white;
        color: blue;
        text-decoration: underline;
      }
    `;
  }}
`;

export const VariantPickerB = styled.div`
  ${({ theme }) => {
    const { typography, spacing } = theme as DefaultTheme;

    return css`
      width: 100%;

      .react-select-wrapper,
      .input {
        width: 75%;
        margin-bottom: ${spacing.spacer};
      }

      .chakra-button {
        font-size: ${theme.typography.baseFontSize};
        font-weight: ${typography.extraBoldFontWeight};
        width: 100%;
      }
    `;
  }}
`;

export const ChangeDatePickerB = styled.div`
  ${({ theme }) => {
    const { spacing, typography } = theme as DefaultTheme;

    return css`
      width: 100%;

      .react-select-wrapper,
      .input {
        width: 75%;
        margin-bottom: ${spacing.spacer};
      }

      .chakra-button {
        font-size: ${theme.typography.baseFontSize};
        font-weight: ${typography.extraBoldFontWeight};
        width: 100%;
        border: none;
        padding: 0;
        text-decoration: underline;
      }

      .chakra-button:hover {
        background-color: white;
        color: blue;
        text-decoration: underline;
      }
    `;
  }}
`;

export const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.error};
`;

// export const PickBoxes = styled.div`

//   .chakra-button {
//     height: 100%;
//     font-weight: ${typography.extraBoldFontWeight};
//   }

//   input {
//     padding: 0.3rem 1rem;
//   }
// `;

export const PickBoxes = styled.div`
  ${({ theme }) => {
    const { typography } = theme as DefaultTheme;

    return css`
      .chakra-button {
        height: 100%;
        font-weight: ${typography.extraBoldFontWeight};
      }

      input {
        padding: 0.3rem 1rem;
      }
    `;
  }}
`;

export const RentButton = styled.div`
  ${({ theme }) => {
    const { typography } = theme as DefaultTheme;

    return css`
      margin-left: 10px;
      margin-right: 10px;

      .chakra-button {
        width: 100%;
        height: 48px;
        font-weight: ${typography.extraBoldFontWeight};
        border-radius: 8px;
      }
    `;
  }}
`;

export const BagIcon = styled.div`
  path {
    fill: white;
  }
`;

export const RemoveIcon = styled.div`
  path {
    fill: black;
  }
`;

export const AlertIcon = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;

  svg {
    height: 24px;
    width: 24px;
  }

  span {
    height: 24px;
    width: 24px;
  }
`;
